import { gql } from "@apollo/client";

export default gql`
  fragment organizationCompetencyCriteria on CompetencyNode {
    criteria {
      edges {
        node {
          id
          content
          level
          inReview
        }
      }
    }
  }
  fragment organizationCompetency on CompetencyNode {
    id
    title
    description
    appliesTo
    appliesToManagementRoles
    appliesToIcRoles
    appliesToTeams {
      edges {
        node {
          id
          title
        }
      }
    }
    appliesToCareerTracks {
      edges {
        node {
          id
          title
        }
      }
    }
    criteriaUniqueness
    canUpdate {
      permission
    }
    ...organizationCompetencyCriteria
  }
  query getOrganizationCompetencies($organizationId: Int!) {
    competencies(organizationId: $organizationId) {
      edges {
        node {
          ...organizationCompetency
        }
      }
    }
  }
`;
